import React, { useState } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";

const DealConfirmModal = ({
  open,
  onClose,
  onConfirm,
  selectedStage,
  dealData,
}) => {
  const isCloseWon = selectedStage?.dealWon || false;
  const isApproved = dealData?.dealVerifiedByAccountant;

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="confirm-modal-title"
      aria-describedby="confirm-modal-description"
      closeAfterTransition
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "25%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 550,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography id="confirm-modal-title" variant="h6" component="h2" mb={2}>
          Confirm Stage Conversion
        </Typography>
        {isApproved || !isCloseWon ? (
          <Typography id="confirm-modal-description" variant="body1" mb={3}>
            Are you sure you want to move this deal to the{" "}
            <strong className="text-capitalize">{selectedStage?.name}</strong>{" "}
            stage? This action will finalize the deal as{" "}
            <strong>{isCloseWon ? "Closed Won" : "Closed Lost"}</strong> and
            cannot be reversed.
          </Typography>
        ) : (
          <Typography id="confirm-modal-description" variant="body1" mb={3}>
            Are you sure you want to move this deal to the{" "}
            <strong className="text-capitalize">{selectedStage?.name}</strong>{" "}
            stage?{" "}
            <span className="bg-info-subtle fw-bold">
              The deal is not yet verified.
            </span>{" "}
            Proceeding will finalize it as{" "}
            <strong>{isCloseWon ? "Closed Won" : "Closed Lost"}</strong> and
            this action cannot be reversed.
          </Typography>
        )}

        <Box display="flex" justifyContent="flex-end" gap={2}>
          <Button variant="outlined" color="inherit" onClick={onClose}>
            Cancel
          </Button>
          {
            <Button
              variant="contained"
              color={isCloseWon ? "success" : "error"}
              onClick={onConfirm}
            >
              {isCloseWon ? "Confirm Won" : "Confirm Lost"}
            </Button>
          }
        </Box>
      </Box>
    </Modal>
  );
};

export default DealConfirmModal;
